<!-- <ion-header [hidden]="inAppNav" class="order-header"> -->
<!--
<ion-header class="order-header">
    <ion-toolbar hideBackButton class="theme1">
        <ion-buttons slot="start">
            <ion-button (click)="backButtonClick()" class="back-btn">
                <ion-icon name="arrow-back"></ion-icon>
                <p *ngIf="!settings.hideBackLbl">{{"global.previous" | translate}}</p>
            </ion-button>
        </ion-buttons>
        <ion-title *ngIf="store">{{store.name}}</ion-title>
        <ion-buttons slot="end">
            <div class="h-nav">

                <ion-icon *ngIf="store.menu.settings.enableSearch" tappable name="ios-search-outline" class="h-nav-cart"
                          (click)="tapSearch()">
                </ion-icon>
                <ion-icon name="cart" class="h-nav-cart" (click)="cartClicked()">
                    &lt;!&ndash; <span *ngIf="!multOrderManager.enableMutlOrder && orderManager.getOrder().orderitems.length > 0" class="news"></span>
                            <span *ngIf="multOrderManager.enableMutlOrder && multOrderManager.getOrderCount() > 0" class="news"></span> &ndash;&gt;
                    <ion-badge *ngIf="!multOrderManager.enableMutlOrder" id="notifications-badge" color="danger">
                        {{orderManager.count}}</ion-badge>
                    <ion-badge *ngIf="multOrderManager.enableMutlOrder" id="notifications-badge" color="danger">
                        {{multOrderManager.getOrderCount()}}</ion-badge>
                </ion-icon>
            </div>
        </ion-buttons>
    </ion-toolbar>

    &lt;!&ndash; <ion-toolbar class="theme1">
        
                <ion-title *ngIf="store">{{store.brand.name}}<span *ngIf="orderService.spot"> ({{orderService.spot}})</span></ion-title>
        
                <ion-buttons end>
                    <button (click)="cartClicked()" ion-button clear icon-left color="contrast" class="order_sum_button md-font-size">
                           <ion-icon class="order_sum_icon" name='cart' color="contrast">
                           </ion-icon>
                    </button>
                </ion-buttons>
            </ion-toolbar> &ndash;&gt;
</ion-header>
-->
<ion-header slot="fixed" [hidden]="inApp">

    <ion-toolbar>
        <ion-buttons slot="start">
            <custom-back-button (backButtonClick)="backButtonClick()"></custom-back-button>
        </ion-buttons>
        <ion-title *ngIf="store">{{store.name}}</ion-title>
        <ion-buttons slot="primary">
            <div class="h-nav">
                <ion-icon *ngIf="store && store.menu.settings.enableSearch && store.menu.settings.catLayout == 'none'"
                          tappable name="ios-search"
                          class="h-nav-cart" (click)="tapSearch()">
                </ion-icon>
            </div>
        </ion-buttons>
    </ion-toolbar>

</ion-header>


<ion-content *ngIf="categories.length > 0" class="basePage">

    <div #transitionAniWrap id="transitionAniWrap" ion-fixed [ngClass]="{'show' : showTransitAni}"></div>


    <div class="content-box">

        <div *ngIf="hasRecommendation">
            <ng-container *ngIf="hasRecommendation">
                <div class="scrollX-wrapper">
                    <p class="page-title">{{"pages.base-category-page.recommendation" | translate}}</p>
                    <div class="category-group-wrapper">

                        <ng-container *ngFor="let recomGroup of recommendationGroups">


                            <ng-container *ngIf="recomGroup.recommendations && recomGroup.recommendations.length > 1">
                                <ion-card class="item-list-box item-box card-shadow twoNhalf-card" no-lines
                                          (click)="recommendationGroupclicked(recomGroup)">
                                    <div item-end class="right-wrapper">
                                        <ion-avatar
                                                *ngIf="recomGroup.recommendations[0].item?.getImage('default',360,true)">
                                            <img *ngIf="recomGroup.recommendations[0].item?.getImage('default',360,true)"
                                                 src="{{recomGroup.recommendations[0].item?.getImage('default',360,true)}}">
                                        </ion-avatar>
                                        <ion-avatar
                                                *ngIf="!recomGroup.recommendations[0].item?.getImage('default',360,true)">
                                            <img src="{{defaultItemImage}}">
                                        </ion-avatar>
                                        <div class="pre-btn-box">
                                            <ion-icon name="md-add-circle" color="success"></ion-icon>
                                        </div>
                                        <!-- <div class="btn-box"
                                                    *ngIf="orderManager.getQuantity(recom.item) > 0 && !isSet(recom) && !recom.item?.variations">
                                                    <button ion-button icon-only clear class="remove-btn"
                                                        (click)="removeClicked(recom.item);$event.stopPropagation();">
                                                        <ion-icon name="ios-remove-circle-outline"></ion-icon>
                                                    </button>
                                                    <span class="qty-text">x{{orderManager.getQuantity(recom?.item)}}</span>
                                                    <button ion-button icon-only clear class="add-btn">
                                                        <ion-icon name="md-add-circle"></ion-icon>
                                                    </button>
                                                </div> -->
                                    </div>

                                    <!-- <div class="sub-info-box">
                                        <ng-container *ngIf="!memberService.getMember()">
                                                    <div class="popularities">
                                                        <ion-icon name="md-star" color="warning"></ion-icon>
                                                        <span>{{getGroupScoreNonMember(recomGroup)}}</span>
                                                    </div>
                                                </ng-container>
                                
                                                <ng-container *ngIf="memberService.getMember()">
                                                    <div class="popularities">
                                                        <ion-icon name="md-beer" color="warning"></ion-icon>
                                                        <span>{{getGroupScore(recomGroup)}}</span>
                                                    </div>
                                                </ng-container>
                                        
                                    </div> -->

                                    <div class="info-box">
                                        <p class="name-text line-clamp">{{ recomGroup.name }}</p>
                                        <div class="price-box">
                                            <!-- <p>&nbsp;</p> -->
                                            <p class="price-text itemPrice-text">{{orderService.sign}}{{ recom?.item?.price }}</p>
                                        </div>
                                    </div>
                                </ion-card>
                            </ng-container>

                            <ng-container *ngIf="recomGroup.recommendations && recomGroup.recommendations.length == 1">
                                <ng-container *ngFor="let recom of recomGroup.recommendations">
                                    <ng-container
                                            *ngIf="!(inventoryManager.isHidden(recom.item) || inventoryManager.isSoldout(recom.item))">
                                        <ion-card class="item-list-box item-box card-shadow twoNhalf-card" no-lines
                                                  (click)="recomItemclicked(recom.item, recom)">
                                            <div item-end class="right-wrapper">
                                                <ion-avatar *ngIf="recom.item?.getImage('default',360,true)">
                                                    <img *ngIf="recom.item?.getImage('default',360,true)"
                                                         src="{{recom.item?.getImage('default',360,true)}}">
                                                </ion-avatar>
                                                <ion-avatar *ngIf="!recom.item?.getImage('default',360,true)">
                                                    <img src="{{defaultItemImage}}">
                                                </ion-avatar>
                                                <div class="pre-btn-box" *ngIf="orderManager.getQuantity(recom.item) == 0">
                                                    <ion-icon name="md-add-circle" color="success"></ion-icon>
                                                </div>
                                                <div class="btn-box animated fadeInRight"
                                                     *ngIf="orderManager.getQuantity(recom.item) > 0 && !isSet(recom) && !recom.item?.variations">
                                                    <div class="remove-btn btn-wrapper" tappable (click)="removeClicked(recom.item);$event.stopPropagation();">
                                                        <ion-icon name="md-remove-circle" color="danger"></ion-icon>
                                                    </div>
                                                    <span class="qty-text">{{orderManager.getQuantity(recom?.item)}}</span>
                                                    <div class="add-btn btn-wrapper">
                                                        <ion-icon name="md-add-circle" color="success"></ion-icon>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="sub-info-box">
                                                <ng-container *ngIf="!memberService.getMember()">
                                                        <div class="popularities">
                                                            <ion-icon name="md-star" color="warning"></ion-icon>
                                                            <span>{{getGroupScoreNonMember(recomGroup)}}</span>
                                                        </div>
                                                    </ng-container>
                            
                                                    <ng-container *ngIf="memberService.getMember()">
                                                        <div class="popularities">
                                                            <ion-icon name="md-beer" color="warning"></ion-icon>
                                                            <span>{{getScore(recom)}}</span>
                                                        </div>
                                                    </ng-container>
                                                
                                            </div> -->
                                            <div class="info-box">
                                                <p class="name-text line-clamp">{{ recom.item.name }}</p>
                                                <div class="price-box">
                                                    <p class="price-text itemPrice-text">{{orderService.sign}}{{ recom?.item?.price }}</p>
                                                </div>
                                            </div>
                                        </ion-card>
                                    </ng-container>
                                </ng-container>
                            </ng-container>

                        </ng-container>

                    </div>
                </div>
            </ng-container>
        </div>


        <div *ngFor="let key of keyMapArray" class="scrollX-wrapper">
            <p class="page-title">{{key}}</p>
            <div class="category-group-wrapper">
                <ion-card *ngFor="let cat of categoryGroupMap[key]"
                          class="item-list-box item-box card-shadow twoNhalf-card" no-lines
                          (click)="subCatClicked(cat, key)">
                    <div slot="end" class="right-wrapper">
                        <ion-avatar>
                            <img [src]="getImage(cat)" [appDefaultImg]="defaultImage">
                        </ion-avatar>
                    </div>

                    <div class="info-box">
                        <p class="name-text line-clamp">{{ cat.name }}</p>
                        <p class="desc-text line-clamp">{{ cat.desc }}</p>

                    </div>
                </ion-card>
            </div>
        </div>

        <div *ngIf="categoryWithoutGroupMap['Category']" class="normal-wrapper">
            <p class="page-title">{{"pages.base-category-page.category" | translate}}</p>
            <div class="category-group-wrapper">
                <ion-card *ngFor="let cat of categoryWithoutGroupMap['Category']"
                          class="item-list-box item-box card-shadow twoNhalf-card AQA-CatGroup" no-lines
                          (click)="subCatClicked(cat, 'Category')">
                    <div item-end class="right-wrapper">
                        <ion-avatar *ngIf="getImage(cat)">
                            <img [src]="getImage(cat)">
                        </ion-avatar>
                    </div>

                    <div class="info-box">
                        <p class="name-text line-clamp">{{ cat.name }}</p>
                        <p class="desc-text line-clamp">{{ cat.desc }}</p>

                    </div>
                </ion-card>
            </div>
        </div>

    </div>
</ion-content>

<ion-content *ngIf="categories.length == 0">
    <div class="emptyPage">

        {{"global.no-menu" | translate}}

    </div>
</ion-content>


<ion-footer>
    <!-- <ion-toolbar >
        <div class="footer-content-box" (click)="cartClicked()">
            <p [ngClass]="{'animated shake' : isBounce}" class="price-text">{{orderManager?.store?.currencySign}} {{getCurrentTotalPrice() | number : '1.'+ orderManager?.getPrecision()||0 + '-' + orderManager?.getPrecision()||2}}</p>
            <span tappable class="action-btn-box">
                <ion-icon name="cart" class="h-nav-cart"></ion-icon>
                <p>{{"pages.virtual-scroll-category-list.cart" | translate}}</p>
                <ion-icon name="aig-arrow-right" class=" animated" [ngClass]="{shaking: multOrderManager.getOrderCount() > 0}"></ion-icon>
            </span>
        </div>
    </ion-toolbar> -->

    <ion-button expand="block" (click)="cartClicked()" class="key-btn-box order-btn full-btn-shadow AQA-key-button">
        <ion-chip [ngClass]="{'animated popped' : isBounce}" class="item-count-chip">
            <ion-label>{{orderManager?.store?.currencySign ===  '€' ? '' : orderManager?.store?.currencySign}}
                {{getCurrentTotalPrice()| number : '1.'+ orderManager?.getPrecision()||0 + '-' + orderManager?.getPrecision()||2}}
                {{orderManager?.store?.currencySign === '€' ? '€' : ''}}
            </ion-label>
        </ion-chip>
        <p class="checkout-text">
            {{"global.checkout" | translate}}
        </p>
        <ion-icon slot="end" name="ios-arrow-forward" class=" animated"
                  [ngClass]="{shaking: multOrderManager.getOrderCount() > 0}"></ion-icon>
    </ion-button>


</ion-footer>
